import imgEvent from "../../assets/webinar1.png";
import imgMeeting from "../../assets/meethome.jpg";
import imgMember from "../../assets/memberhome.jpg";
import { Link } from "react-router-dom";

export default function ExploreDivisionSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight mb-4">
              Explore Our Division
            </h2>
            <p className="text-gray-600 mt-2 text-lg mb-5">
              Learn more about our activities, meetings, and member countries
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Events */}

            <Link
              to="/events"
              className="group bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <img
                src={imgEvent}
                alt="Events"
                className="rounded-t-2xl h-48 w-full object-cover"
              />
              <div className="p-8">
                <h3 className="text-xl font-semibold text-gray-900 group-hover:text-blue-600">
                  Events
                </h3>
                <p className="text-sm text-gray-600 mt-2">
                  Discover our latest virtual and hybrid events across the
                  region.
                </p>
              </div>
            </Link>

            {/* Meetings */}
            <Link
              to="/meetings"
              className="group bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <img
                src={imgMeeting}
                alt="Meetings"
                className="rounded-t-2xl h-48 w-full object-cover"
              />
              <div className="p-8">
                <h3 className="text-xl font-semibold text-gray-900 group-hover:text-blue-600">
                  Meetings
                </h3>
                <p className="text-sm text-gray-600 mt-2">
                  See how member states collaborate through formal in-person
                  meetings.
                </p>
              </div>
            </Link>

            {/* Members */}
            <Link
              to="/members"
              className="group bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <img
                src={imgMember}
                alt="Members"
                className="rounded-t-2xl h-48 w-full object-cover"
              />
              <div className="p-8">
                <h3 className="text-xl font-semibold text-gray-900 group-hover:text-blue-600">
                  Members
                </h3>
                <p className="text-sm text-gray-600 mt-2">
                  Meet the 12 countries that form the UNGEGN ASE Division.
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
